import { atom } from "jotai";

/**
 * Jotai atom for managing the sidebar collapsed state.
 * Initializes from localStorage if available, otherwise defaults to false (expanded).
 * This state controls whether the sidebar is collapsed or expanded in the UI.
 */
export const SidebarStateAtom = atom(
  JSON.parse(localStorage.getItem("collapsed") || "false")
);

/**
 * Side effect to synchronize the sidebar state with localStorage.
 * When the component using this atom mounts, it retrieves the saved state from localStorage.
 * Any changes to the atom's state are automatically persisted to localStorage.
 */
SidebarStateAtom.onMount = (setAtom) => {
  const savedState = localStorage.getItem("collapsed");
  if (savedState !== null) {
    setAtom(JSON.parse(savedState));
  }
};
